import { stringify } from 'qs';
import SuperFetchV2 from '../../superFetchV2';
import {
  AlimtalkSendCancelResponse,
  AlimtalkSendHistoryDetailResponse,
  AlimtalkSendHistoryListQueryParams,
  AlimtalkSendHistoryListResponse,
} from '../../../views/alimtalk/send/history/types';

/**
 *  ⚠️ 세 요청 모두 `skipErrorModal` 을 켠다 (promotionScheduleApi.findOne 관례).
 *  ALIMTALK_SEND003~008 이 ERROR_RESPONSE 에 등록돼 있어 인터셉터 모달이 뜨면
 *  - 목록/상세: 화면 에러 Result 와 같은 말을 두 번 하고, 상세 404(ALIMTALK_SEND008) 는 모달을 닫을 때까지 스피너가 멈춘다.
 *  - 취소: mutation onError 토스트와 중복된다.
 *  `skipFullscreenLoader` 도 세 요청 모두 켠다 (payMethodExhibitApi·searchDictionaryApi 관례).
 *  로딩은 화면 안에서 표시한다 — 목록: Table loading / 상세: Spin / 취소: Popconfirm 확인 버튼 loading.
 */
const requestOptions = { skipFullscreenLoader: true, skipErrorModal: true };

export const alimtalkSendHistoryApi = {
  /** GET /api/alimtalk-send-histories */
  getList: (params: AlimtalkSendHistoryListQueryParams): Promise<AlimtalkSendHistoryListResponse> =>
    SuperFetchV2.get('/alimtalk-send-histories', {
      ...requestOptions,
      params,
      paramsSerializer: (query: AlimtalkSendHistoryListQueryParams) =>
        stringify(query, { arrayFormat: 'comma', skipNulls: true }),
    }),

  /** GET /api/alimtalk-send-histories/:id */
  getDetail: (id: number): Promise<AlimtalkSendHistoryDetailResponse> =>
    SuperFetchV2.get(`/alimtalk-send-histories/${id}`, requestOptions),

  /** DELETE /api/alimtalk-sends/:id (기존 예약 취소 API 재사용) */
  cancel: (id: number): Promise<AlimtalkSendCancelResponse> =>
    SuperFetchV2.delete(`/alimtalk-sends/${id}`, requestOptions),
};
